module.exports = __webpack_public_path__ + "img/u-matrix.a61e7fa2.png";